import { render, staticRenderFns } from "./auth-layout.vue?vue&type=template&id=77d7f53f&scoped=true"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"
import style0 from "./auth-layout.vue?vue&type=style&index=0&id=77d7f53f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d7f53f",
  null
  
)

export default component.exports